import { render } from "./TissBatchDetailModal.vue?vue&type=template&id=f10e88fe&scoped=true"
import script from "./TissBatchDetailModal.vue?vue&type=script&lang=js"
export * from "./TissBatchDetailModal.vue?vue&type=script&lang=js"

import "./TissBatchDetailModal.vue?vue&type=style&index=0&id=f10e88fe&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f10e88fe"]])

export default __exports__